import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Paper, Box, Button, Chip, CircularProgress,
  Alert, Grid, Card, CardMedia, Divider,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export default function VistoriaDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [vistoria, setVistoria] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3992/api';

  useEffect(() => {
    carregarVistoria();
  }, [id]);

  async function carregarVistoria() {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/vistorias/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!res.ok) throw new Error('Vistoria não encontrada');
      const dados = await res.json();
      setVistoria(dados);
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const getStatusColor = (status) => {
    const colors = {
      'em_andamento': 'warning',
      'concluida': 'success',
      'cancelada': 'error'
    };
    return colors[status] || 'default';
  };

  const getStatusLabel = (status) => {
    const labels = {
      'em_andamento': 'Em Andamento',
      'concluida': 'Concluída',
      'cancelada': 'Cancelada'
    };
    return labels[status] || status;
  };

  if (loading) return <Box sx={{ p: 3, textAlign: 'center' }}><CircularProgress /></Box>;
  if (!vistoria) return <Alert severity="error">{error || 'Vistoria não encontrada'}</Alert>;

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate('/vistorias')} sx={{ mb: 2 }}>
        Voltar
      </Button>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <div>
            <h2>{vistoria.nome_cliente}</h2>
            <p>{vistoria.marca} {vistoria.modelo} - <strong>{vistoria.placa}</strong></p>
          </div>
          <Chip
            label={getStatusLabel(vistoria.status)}
            color={getStatusColor(vistoria.status)}
            size="small"
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6}>
              <p><strong>KM Final:</strong> {vistoria.km_final} km</p>
            </Grid>
            <Grid item xs={12} sm={6}>
              <p><strong>Combustível:</strong> {vistoria.nivel_combustivel}%</p>
            </Grid>
            <Grid item xs={12} sm={6}>
              <p><strong>Data:</strong> {new Date(vistoria.data_vistoria || vistoria.data_hora_inicio).toLocaleDateString('pt-BR')}</p>
            </Grid>
            <Grid item xs={12} sm={6}>
              <p><strong>Funcionário:</strong> {vistoria.funcionario_nome || 'N/A'}</p>
            </Grid>
            {vistoria.observacoes && (
              <Grid item xs={12}>
                <p><strong>Observações:</strong></p>
                <p>{vistoria.observacoes}</p>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper>

      {/* FOTOS */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <h3 style={{ margin: 0 }}>Fotos {vistoria.fotos && vistoria.fotos.length > 0 && `(${vistoria.fotos.length})`}</h3>
        </Box>
        {vistoria.fotos && vistoria.fotos.length > 0 ? (
          <Grid container spacing={2}>
            {vistoria.fotos.map(foto => (
              <Grid item xs={12} sm={6} md={4} key={foto.id}>
                <Card>
                  <CardMedia
                    component="img"
                    height="200"
                    image={foto.url}
                    alt={foto.descricao || 'Foto vistoria'}
                    sx={{ objectFit: 'cover', cursor: 'pointer' }}
                    onClick={() => window.open(foto.url, '_blank')}
                  />
                  <Box sx={{ p: 1 }}>
                    <Chip label={foto.tipo_foto} size="small" sx={{ mb: 1 }} />
                    {foto.descricao && <p style={{ fontSize: '0.9em', margin: 0 }}>{foto.descricao}</p>}
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Alert severity="info">Nenhuma foto adicionada ainda</Alert>
        )}
      </Paper>

      {/* CHECKLIST */}
      {vistoria.checklist && vistoria.checklist.length > 0 && (
        <Paper sx={{ p: 3, mb: 3 }}>
          <h3>Checklist</h3>
          <TableContainer>
            <Table>
              <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell><strong>Item</strong></TableCell>
                  <TableCell><strong>Status</strong></TableCell>
                  <TableCell><strong>Observação</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {vistoria.checklist.map(item => (
                  <TableRow key={item.id}>
                    <TableCell>{item.item}</TableCell>
                    <TableCell>
                      <Chip
                        label={item.verificado ? 'OK' : 'Não verificado'}
                        color={item.verificado ? 'success' : 'default'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{item.observacao || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

    </Container>
  );
}
